import { Component, ElementRef, OnInit, Renderer, ViewEncapsulation,ViewChildren, QueryList, } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util.service';
import { HandleRequestService } from 'src/app/shared/services/handle-request.service';
import { APIResponse } from 'src/app/shared/models/api-response';
import { ActivatedRoute } from '@angular/router';
import { Student } from 'src/app/shared/models/student';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-runner4',
  templateUrl: './runner4.component.html',
  styleUrls: ['./runner4.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class Runner4Component implements OnInit {
  @ViewChildren('canvas') canvasElements: QueryList<ElementRef<HTMLCanvasElement>>;
  canvases = [
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
  ];

  
  resultData: any[] = [];
  student: Student;
  isIOS = false;

  defaultData = [
    [], // 0
    ['269', '385', '174', '126', '126', '107', '170'], // 1
    ['24.44', '22.21', '23.21', '2.2', '65.32', '51.15', '43.14', '20', '23.14', '44.23'], // 2
    ['560', '299', '374', '836', '494', '918', '799'], // 3
    ['798', '2931', '3745', '948', '4208', '40578', '44037', '30565', '43096', '16212'], // 4
    [], // 5
    ['88', '18', '55', '93', '2', '30', '40', '37', '56', '6'], // 6
    ['9.79', '9.98', '6.87', '8.77', '5', '8.66', '9.99'], // 7
    ['211', '142', '214', '554', '413', '443', '545'], // 8
    [], // 9
    ['110', '385', '64', '232', '784', '342', '176', '150', '234', '658'], // 10
    [], // 11
    ['8', '3', '7', '9', '10', '14', '15', '14'], // 12
    ['253', '165', '134', '194', '150', '166', '143', '217'], // 13
    ['20.3', '22.14', '10', '25.12', '45.23', '11.31', '22.04', '13.34', '11.07', '27.36'], // 14
    ['485', '760', '497', '855', '431', '326', '296'], // 15
    ['8316', '1943', '2871', '884', '455', '4370', '2945', '1326', '1368', '1815'], // 16
    [], // 17
    ['76', '61', '57', '81', '50', '61', '52', '18', '44', '35'], // 18
    ['0.02', '1', '2', '4.04', '4.45', '3', '4.32'], // 19
    ['423', '425', '554', '654', '64', '544', '461'], // 20
    [], // 21
    ['441', '216', '34', '72', '156', '192', '215', '280', '603', '200'], // 22
    [], // 23
    ['2', '4', '6', '8', '9', '3', '5', '7', '5', '1', '6', '2', '4', '3', '1', '9', '3', '2', '6',
      '1', '2', '5', '6', '8', '7', '7', '6', '3', '8', '1', '9', '4', '5', '8', '9', '4', '6', '3',
    '3', '2', '9', '7', '5', '5', '8', '9', '2', '7', '1', '4', '1', '4', '3', '5', '2', '6', '8'], // 24
    ['171', '145', '100', '103', '248', '120', '191'], // 25
    ['95.59', '39.46', '92.87', '67.55', '34.58', '79.55', '89.77', '12.44', '24.47', '21.84'], // 26
    ['173', '341', '624', '550', '102', '722', '806', '985', '117', '540'], // 27
    ['2241', '1536', '6586', '414', '5612', '13162', '19964', '25004', '12786', '37928'], // 28
    ['22', '72', '44', '72', '94', '66', '88', '17', '37', '90'], // 29
    ['8.56', '8.24', '2.41', '1.18', '2.31', '0.44', '3.32', '4.79', '5.5', '9.88'], // 30
    ['248', '687', '883', '532', '512', '724', '570', '512', '7', '856'], // 31
    ['2016', '1308', '2451', '1516', '311', '1290', '7664', '1716', '1095', '4239'], // 32
    [], // 33
    [], // 34
    [], // 35
    [], // 36
    ['262', '85', '242', '232', '214', '34', '232'], // 37
    ['71.42', '98.02', '88.2', '98.2', '30.22', '14.23', '52.41', '36.1', '50', '99.64'], // 38
    ['531', '678', '837', '142', '945', '145', '938', '318', '844', '368'], // 39
    ['3828', '4836', '2788', '2210', '4389', '42848', '18465', '44682', '34584', '21260'], // 40
    ['8', '87', '74', '37', '71', '36', '13', '55', '29', '83'], // 41
    ['7.91', '7.95', '9.25', '8.87', '7.4', '8.5', '9.81', '4.16', '1.92', '8.69'], // 42
    ['439', '774', '25', '84', '876', '513', '947', '703', '243', '401'], // 43
    ['3372', '1180', '8676', '1225', '5864', '4595', '5376', '1760', '6657', '2596'], // 44
    [], // 45
    [], // 46
    [], // 47
    [
      '0', '0', '0', '0', '1', '1', '1', '1', '0', '0',
      '1', '0', '0', '0', '0', '1', '1', '1', '1', '0',
      '1', '1', '1', '1', '1', '0', '1', '0', '0', '0',
      '1', '0', '0', '0', '0', '0', '1', '0', '0', '0',
      '1', '1', '1', '1', '1', '0', '1', '1', '1', '0',
      '0', '1', '1', '1', '1', '0', '1', '1', '1', '0',
      '0', '0', '0', '1', '0', '0', '0', '1', '1', '0',
      '0', '1', '1', '1', '0', '0', '0', '1', '1', '0',
      '0', '1', '1', '1', '1', '1', '1', '1', '0', '0',
      '0', '0', '0', '1', '0', '0', '1', '1', '1', '1',
    ], // 48
    ['133', '215', '129', '85', '23', '43', '106'], // 49
    ['72.12', '88.93', '16.18', '82.15', '74.62', '5.18', '93.09', '26.83', '62.71', '89.27'], // 50
    ['954', '574', '298', '46', '846', '185', '643', '921', '969', '742'], // 51
    ['3528', '2340', '8184', '1632', '476', '24255', '22965', '61110', '17396', '14532'], // 52
    ['10', '2', '33', '7', '6', '17', '23', '48', '20', '14', '16', '6', '19', '6', '9', '7'], // 53
    ['71', '45', '35', '2', '40', '33', '72', '38', '68', '25'], // 54
    ['13.38', '5.62', '0.48', '5.95', '0.19', '4.98', '0.03', '3.85', '3.87', '4.44'], // 55
    ['805', '860', '716', '666', '420', '749', '172', '422', '387', '736'], // 56
    ['4168', '1917', '1920', '1856', '3390', '6930', '7824', '836', '2247', '8028'], // 57
    [], // 58
    [], // 59
    [], // 60
    [], // 61
    ['178', '144', '84', '143', '131', '109', '125'], // 62
    ['531.08', '425.42', '757.4', '827.85', '962.14', '962.14', '459.06', '540.71', '586.51', '876.7'], // 63
    ['2127', '475', '1561', '895', '2167', '1158', '1004', '1205', '1511', '1073'], // 64
    ['1512', '1344', '2516', '1375', '2160', '1932', '2142', '3564', '4784', '2769'], // 65
    ['31', '12', '4', '9', '3', '9', '3', '13', '57', '11'], // 66
    ['25', '37', '5', '25', '5', '69', '70', '47', '152', '43'], // 67
    ['56.8', '86.31', '39.34', '95.58', '96.58', '22.38', '89.7', '83.88', '25', '20.35'], // 68
    ['52', '65', '100', '620', '976', '637', '55', '170', '544', '321'], // 69
    ['2736', '2760', '378', '3003', '1377', '12662', '17180', '15336', '58617', '11872'], // 70
    [
      '3', '7', '2', '1', '8', '7', '2', '5', '6', '4',
      '9', '5', '9', '1', '3', '4', '6', '7', '8', '5',
      '4', '1', '7', '2', '6', '4', '3', '9', '8', '9',
      '7', '6', '4', '3', '5', '6', '7', '9', '2', '3',
      '3', '1', '8', '4', '6', '5', '1', '5', '8'
    ], // 71
    [], // 72
    [], // 73
    [], // 74
    ['171', '239', '245', '107', '135', '173', '139'], // 75
    ['735.46', '748.25', '430.98', '843.48', '183.01', '196.63', '216.65', '111.96', '789.52', '504.29'], // 76
    ['1924', '1088', '1295', '879', '1254', '1441', '1086', '1794', '740', '462'], // 77
    ['2926', '900', '3492', '2280', '1248', '4428', '1971', '5292', '1110', '5226'], // 78
    ['32', '8', '12', '24', '27', '15', '5', '14', '14', '22'], // 79
    ['57', '28', '28', '16', '39', '34', '75', '38', '43', '14'], // 80
    ['48.11', '66.79', '47.99', '50.33', '83.2', '42.87', '3.31', '47.98', '10.32', '36.22'], // 81
    ['597', '632', '421', '992', '437', '391', '314', '212', '182', '103'], // 82
    ['4705', '304', '2401', '1473', '5508', '3558', '11823', '50916', '19368', '54439'], // 83
    [], // 84
    [], // 85
    [], // 86
    [
      '0', '0', '0', '0', '1', '1', '1', '1', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '1', '1', '1', '0', '0', '0', '0', '1', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '0', '1', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '1', '1', '1', '1', '0', '0', '0', '1', '0', '1', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '0', '0', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '0', '0', '0', '0', '0', '1', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '1', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '1', '0', '0', '0', '0', '0',
      '0', '0', '1', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '0', '0', '0', '0', '0', '0',
      '0', '0', '1', '1', '1', '1', '0', '0', '0', '0', '0', '0', '1', '1', '0', '0', '0', '0', '0', '0',
      '0', '0', '1', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'
    ], // 87
    ['262', '89', '215', '215', '203', '203', '120'], // 88
    ['302.21', '145.21', '302.69', '493.77', '267.71', '586.98', '172.01', '867.52', '867.52', '670.03'], // 89
    ['1121', '1225', '1257', '1490', '1373', '1371', '1605', '1707', '1349', '1462'], // 90
    ['338', '2244', '5472', '4160', '3927', '2254', '6272', '2064', '2565', '3087'], // 91
    ['179', '86', '169', '236', '31', '131', '141', '15', '218', '121', '349', '107', '105', '89', '157'], // 92
    ['93', '14', '35', '6', '49', '72', '29', '33', '72', '3'], // 93
    ['76.62', '35.04', '28.72', '72.62', '70.63', '85.47', '99.84', '33.76', '36.09', '64.32', '77.75', '77.75', '97.04', '63.88'], // 94
    ['230', '856', '232', '745', '426', '232', '335', '244', '766', '596'], // 95
    ['6615', '1460', '1431', '3355', '672', '15868', '28956', '31124', '47537', '52264'], // 96
    [], // 97
    [], // 98
    [], // 99
    [
      '1', '0', '0', '0', '0', '0', '0', '1', '1', '1',
      '0', '1', '0', '0', '1', '0', '0', '0', '1', '1',
      '0', '1', '1', '1', '1', '1', '0', '0', '1', '0',
      '0', '0', '0', '0', '0', '0', '0', '0', '0', '0',
      '0', '0', '0', '0', '0', '0', '0', '1', '1', '1',
      '0', '0', '0', '0', '0', '0', '0', '0', '1', '0',
      '0', '1', '0', '0', '1', '1', '0', '1', '1', '1',
      '1', '0', '1', '1', '1', '1', '1', '1', '1', '1',
      '0', '1', '1', '1', '0', '1', '1', '0', '1', '1',
      '0', '0', '1', '0', '0', '1', '0', '1', '1', '0',
    ], // 100
    ['192', '254', '138', '150', '117', '182', '248'], // 101
    ['999.47', '443.77', '477.98', '439.5', '699.6', '116.75', '366.1', '183.73', '211.06', '904.91'], // 102
    ['1478', '1490', '869', '1310', '1244', '1255', '1439', '1164', '1410', '1412'], // 103
    ['2548', '1440', '2546', '2679', '2352', '533', '6534', '2336', '3318', '2691'], // 104
    ['158', '28', '147', '146', '32', '377', '154', '122', '278', '146', '107', '84', '429', '667', '47'], // 105
    ['54', '15', '93', '33', '61', '39', '15', '82', '46', '80'], // 106
    ['24.75', '55.48', '36.45', '14.25', '80.84', '75.96', '27.5', '30.31', '61.58', '21.32'], // 107
    ['367', '250', '549', '798', '804', '278', '968', '621', '227', '616'], // 108
    ['2104', '4879', '2688', '642', '520', '7390', '17694', '24765', '29984', '58482'], // 109
    ['13', '5', '9', '9', '11', '44', '9', '4', '9', '26'], // 110
    [], // 111
    [], // 112
    [], // 113
    [], // 114
    ['137', '225', '256', '148', '182', '155', '305'], // 115
    ['817.08', '990.74', '393.77', '573.85', '1003.26', '867.01', '440.78', '256.59', '650.93', '925.56'], // 116
    ['1226', '1717', '1146', '1134', '1551', '1114', '1309', '1113', '1325', '1421'], // 117
    ['6068', '1924', '6144', '3608', '1430', '3248', '3397', '3201', '1782', '1170'], // 118
    ['163', '76', '81', '144', '65', '43', '84', '55', '474', '69', '1245', '963', '463', '4679', '963', '589', '879', '943', '682', '762'], // 119
    ['39', '15', '62', '5', '40', '49', '51', '71', '19', '23'], // 120
    ['48.63', '31.3', '79.01', '76.18', '95.86', '88.1', '3.54', '30.36', '40.33', '67.04'], // 121
    ['661', '985', '990', '792', '801', '950', '85', '814', '182', '434'], // 122
    ['186', '1862', '1890', '1550', '3720', '49347', '37145', '46260', '41643', '9186'], // 123
    ['21', '9', '6', '16', '4', '6', '5', '8', '12', '8'], // 124
    [], // 125
    [], // 126
    [], // 127
    ['667', '761', '678', '626', '719', '387', '602', '287', '989', '308', '817.17', '990.74', '880.77', '999.47', '116.75', '443.77', '699.6', '904.91', '580', '234.15'], // 128
    ['2769', '4784', '3564', '2142', '1932', '10935', '19750', '37144', '7044', '23694'], // 129
    ['58', '63', '83', '82', '96', '179', '47', '229', '63', '71', '297', '116', '49', '437', '84', '99', '115', '48', '98', '47'], // 130
    [], // 131
    [], // 132
    [], // 133
    ['56', '74', '47', '65', '77', '47', '47', '83', '69', '5'], // 134
    ['56.8', '96.98', '83.88', '46.85', '93.56', '86.31', '52.57', '54.92', ' 80.75'], // 135
    ['1683', '3267', '5535', '3536', '1568', '9130', '41202', '6594', '20812', '89928'], // 136
  ];
  type = 'runner4';

  constructor(
    private utilService: UtilService,
    private httpService: HandleRequestService,
    private route: ActivatedRoute,
    private elRef: ElementRef,
    private toastr: ToastrService,
    private renderer: Renderer
  ) { }

  ngOnInit() {
    if (/iPad|iPhone|iPod/.test(window.navigator.userAgent)) {
      this.isIOS = true;
    }

    for (var i = 0; i < 137; i++) {
      this.resultData.push({
        values: [],
        times: '',
        count: 0,
        correctAnswers: 10,
        resultIsIncorrect: [false,false,false,false,false,false,false,false,false,false],
        finished: false
      })
    }
    
    this.route.data.subscribe(x => {
      if (x.hasOwnProperty('profile')) {
        const response = x.profile as APIResponse;
        this.student = response.data as Student;
      }

      this.httpService.post('/smartpdf/get', {
        type: this.type,
        user_id: this.student._id,
      }).then(
        (res: APIResponse) => {
          if (res.data.smartpdf) {
            this.resultData = res.data.smartpdf.data.result;
          }
          this.canvases.forEach((canvas, index) => {
            if (!canvas.context) {
              canvas.context = this.canvasElements.toArray()[index].nativeElement.getContext('2d');
            }
          });
          this.loadDrawing();
        }, () => {
         
        }
      );
      
    });
  }

  startDrawing(e: TouchEvent, index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = true;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const event = e.touches[0];
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.beginPath();
    canvas.context.moveTo(x, y);
  }

  draw(e: TouchEvent, index: number): void {
    const canvas = this.canvases[index];
    if (!canvas.drawing) return;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const event = e.touches[0];
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.lineTo(x, y);
    canvas.context.stroke();
  }

  stopDrawing(index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = false;
    canvas.context.closePath();
  }

  startDrawing1(event: MouseEvent, index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = true;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.beginPath();
    canvas.context.moveTo(x, y);
  }

  draw1(event: MouseEvent, index: number): void {
    const canvas = this.canvases[index];
    if (!canvas.drawing) return;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.lineTo(x, y);
    canvas.context.stroke();
  }

  stopDrawing1(index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = false;
    canvas.context.closePath();
  }

  saveDrawing(index: number): void {
    this.toastr.info('Saving...');
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const dataURL = canvasElement.toDataURL();
    this.httpService.post('/smartcanvas/update', {
      type: this.type,
      user_id: this.student._id,
      serial: index,
      data: dataURL
    }).then(
      (res: APIResponse) => {
        this.toastr.clear();
        this.toastr.success('Successfully Saved');
      }, () => {
      }
    );
  }

  async loadDrawing() {
    for (var index in this.canvases) {
      this.httpService.post('/smartcanvas/get', {
        type: this.type,
        user_id: this.student._id,
        serial: index
      }).then(
        (res: APIResponse) => {
          if (res.data.smartcanvas) {
            const img = new Image();
            img.onload = () => {
            const canvasElement = this.canvasElements.toArray()[index].nativeElement;
              const context = canvasElement.getContext('2d');
              context.clearRect(0, 0, canvasElement.width, canvasElement.height);
              context.drawImage(img, 0, 0);
            };
            img.src = res.data.smartcanvas.data;
          }
        }, () => {
         
        }
      );

      await this.delay(2000);
    }
    
  }

  backToSavedImage(index: number) {
    this.httpService.post('/smartcanvas/get', {
      type: this.type,
      user_id: this.student._id,
      serial: index
    }).then(
      (res: APIResponse) => {
        if (res.data.smartcanvas) {
          const img = new Image();
          img.onload = () => {
          const canvasElement = this.canvasElements.toArray()[index].nativeElement;
            const context = canvasElement.getContext('2d');
            context.clearRect(0, 0, canvasElement.width, canvasElement.height);
            context.drawImage(img, 0, 0);
          };
          img.src = res.data.smartcanvas.data;
        }
      }, () => {
       
      }
    );
  }

  clearCanvas(index: number): void {
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const context = canvasElement.getContext('2d');
    context.clearRect(0, 0, canvasElement.width, canvasElement.height);
  }

  canvasPropertiesChanges(): void {
    this.canvases.forEach(canvas => {
      if (!canvas.isEraser) {
        canvas.context.strokeStyle = canvas.brushColor;
      }
      canvas.context.lineWidth = canvas.brushSize;
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  quastionConfirm(index) {
    this.resultData[index].finished = true;
    if (this.resultData[index].count < 2) {
      this.resultData[index].count++;
      let allCorrect = true;
      for (let i in this.defaultData[index]) {
        if (this.defaultData[index][i] != this.resultData[index].values[i]) {
          allCorrect = false;
        }
      }
      if (!allCorrect && this.resultData[index].count == 1) {
        this.toastr.error('Corrige el resultado en rojo y vuelve a picar. Solo tienes una oportunidad de corregir.');
      }
    }
    this.saveData();
  }

  quastionChange(index) {
    this.resultData[index].finished = false;
  }

  clickedNumbers(i, j) {
    if (this.resultData[i].finished && this.resultData[i].count >= 2) {
      return;
    }
    this.resultData[i].finished = false;
    if (this.resultData[i].values[j] == '1') {
      this.resultData[i].values[j] = '0';
    } else {
      this.resultData[i].values[j] = '1';
    }
  }

  quastionConfirm1(index) {
    this.resultData[index].finished = true;
    this.saveData();
  }

  correctAnswerCheck(i, j) {
    if (!this.resultData[i].resultIsIncorrect[j] && this.resultData[i].finished){
      if (document.activeElement && document.activeElement !== document.body) {
        this.renderer.invokeElementMethod(
          this.elRef.nativeElement.ownerDocument.activeElement, 'blur');
      }
      this.resultData[i].resultIsIncorrect[j] = true;
      this.resultData[i].correctAnswers--;
      this.saveData();
    }
  }

  saveData() {
    this.toastr.info('Saving...');
    this.httpService.post('/smartpdf/update', {
      type: this.type,
      user_id: this.student._id,
      data: {
        result: this.resultData
      }
    }).then(
      (res: APIResponse) => {
        this.toastr.success('Saved');
      }, () => {
      }
    );
  }
}
